import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { ZoomableImage } from "./ZoomableImage";

// Fetches a protected file and previews it inline: PDFs in an embedded viewer, images with zoom/rotate.
export const FilePreview = ({ url, contentType, className = "", testPrefix = "receipt" }) => {
  const [src, setSrc] = useState(null);
  const [kind, setKind] = useState(contentType || "");
  const [err, setErr] = useState(false);
  useEffect(() => {
    let obj;
    setSrc(null); setErr(false);
    axios.get(url, { responseType: "blob" }).then((r) => {
      const type = r.data.type || r.headers?.["content-type"] || contentType || "";
      setKind(type);
      obj = URL.createObjectURL(type ? new Blob([r.data], { type }) : r.data);
      setSrc(obj);
    }).catch(() => setErr(true));
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [url]); // eslint-disable-line
  if (err) return <p className="text-sm text-slate-400" data-testid={`${testPrefix}-preview-error`}>File unavailable</p>;
  if (!src) return <div className="h-40 flex items-center justify-center text-slate-400"><Loader2 className="animate-spin" /></div>;
  if (kind.includes("pdf")) {
    return (
      <div className={className} data-testid={`${testPrefix}-preview-pdf`}>
        <object data={src} type="application/pdf" className="w-full h-[480px] rounded border bg-slate-50" aria-label="PDF preview">
          <iframe title="pdf" src={src} className="w-full h-[480px] rounded border" />
        </object>
        <a href={src} target="_blank" rel="noreferrer" className="text-xs text-blue-700 hover:underline mt-1 inline-block" data-testid={`${testPrefix}-open-pdf`}>Open PDF in a new tab</a>
      </div>
    );
  }
  if (kind.startsWith("image/")) return <ZoomableImage src={src} className={className} />;
  return (
    <div className={`rounded border bg-slate-50 p-6 text-center text-sm text-slate-500 ${className}`} data-testid={`${testPrefix}-preview-unsupported`}>
      No inline preview for this file type. <a href={src} download className="text-blue-700 hover:underline">Download it</a> to open.
    </div>
  );
};
